"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesSocialTypeGroupSchema = void 0;
exports.ServicesSocialTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/social.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesSocialTypeGroup",
    "description": "ServicesSocialTypeGroup represents one of the following types: FacebookPost, FacebookFollow, InstagramEmbed, InstagramFollow, MixcloudAudio, Snapchat, SoundcloudSocialLink, SpotifySocialLink, TikTokEmbed, TikTokSocialLink, TwitchLiveVideo, TwitchLiveVideo, TwitchSocialLink, TwitterTweetEmbed, TwitterFollow, VKVideo, YoutubePlaylist, YoutubeSocialLink, YoutubeVideo",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-socialembed-post/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/facebook-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/instagram-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mixcloud-audio/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/snapchat-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/soundcloud-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/spotify-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-embed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/tiktok-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-socialembed/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitter-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-sociallink/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3R5cGUtZ3JvdXBzL3NlcnZpY2VzL3NvY2lhbC5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxLQUFLLEVBQUUseUVBQXlFO0lBQ2hGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHlCQUF5QjtJQUNsQyxhQUFhLEVBQUUsZ1hBQWdYO0lBQy9YLE9BQU8sRUFBRTtRQUNQO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDhGQUE4RjtTQUN2RztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHdGQUF3RjtTQUNqRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLG9GQUFvRjtTQUM3RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHlGQUF5RjtTQUNsRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLG1GQUFtRjtTQUM1RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHdGQUF3RjtTQUNqRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDBGQUEwRjtTQUNuRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHVGQUF1RjtTQUNoRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLGlGQUFpRjtTQUMxRjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHNGQUFzRjtTQUMvRjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHFGQUFxRjtTQUM5RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHFGQUFxRjtTQUM5RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHNGQUFzRjtTQUMvRjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHdGQUF3RjtTQUNqRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHVGQUF1RjtTQUNoRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLDZFQUE2RTtTQUN0RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHFGQUFxRjtTQUM5RjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLHVGQUF1RjtTQUNoRztRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFLGtGQUFrRjtTQUMzRjtLQUNGO0NBQ0YsQ0FBQSJ9